import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformKeysToCamelCase } from 'helpers/core';

import URLS from 'constants/urls';

const handler = ({ httpClient }, venueId) => {
  const endpoint = URLS.ratings.classes(venueId);

  return httpClient.get(endpoint).then(({ data }) => transformKeysToCamelCase(data));
};

export default makeEntityScaffold('SAGA.API.RATINGS_CLASSES', handler, { defaultKey: 1 });
